export class ZoomOptions {
    public loopMinValue: number = 30;
    public loopMaxValue: number = 300;
    public loopStep: number = 10;
    public loop: number = 100;

    public fullSizeEnabled: boolean = true;
    public fullWidthEnabled: boolean = true;
    public fullHeightEnabled: boolean = true;

    public fullScreen: boolean = false;

    private _parenSelector: string;
    private _childSelector: string;

    constructor(
        private $element: JQuery<HTMLElement>,
        private className = ''
    ) {
        this._parenSelector = `.${this.className}`;
        this._childSelector = `.${this.className}__editor`;
    }

    public parentSelector() {
        return this._parenSelector;
    }

    public setParentSelector(selector: string) {
        this._parenSelector = selector;
    }

    public childSelector() {
        return this._childSelector;
    }

    public setChildSelector(selector: string) {
        this._childSelector = selector;
    }

    public fullSizeAction(fullsize: boolean) {
        if (fullsize) {
            $('.a-main-header,.a-main-footer').hide();
            this.$element.closest(`.${this.className}`).addClass(`${this.className}--full-size`);
            this.fullScreen = true;
        } else {
            $('.a-main-header,.a-main-footer').show();
            this.$element.closest(`.${this.className}`).removeClass(`${this.className}--full-size`);
            this.fullScreen = false;
        }
    }

    public get value() {
        // let global:number = parseInt(localStorage.getItem('a9.zoom.value'), 10) || 100;
        return this.loop; // * global / 100;
    }

    public set value(value: number) {
        this.loop = value;
    }
}
